import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupTypeOffice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42 0H0V42H42V0Z",
			fill: "#C2E6F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.97674 10.7979H32.2133C33.0116 10.7979 33.6588 11.443 33.6588 12.2367V26.6719C33.6588 27.4665 33.0107 28.1108 32.2133 28.1108H9.97674C9.17848 28.1108 8.53125 27.4657 8.53125 26.6719V12.2367C8.53125 11.4421 9.17931 10.7979 9.97674 10.7979Z",
			fill: "#002749"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.215 12.0351C32.3262 12.0351 32.4174 12.1251 32.4174 12.2366V26.6718C32.4174 26.7825 32.327 26.8734 32.215 26.8734H9.9784C9.8672 26.8734 9.77593 26.7833 9.77593 26.6718V12.2366C9.77593 12.126 9.86637 12.0351 9.9784 12.0351H32.215ZM32.215 9.55957H9.9784C8.49308 9.55957 7.28906 10.7581 7.28906 12.2366V26.6718C7.28906 28.1504 8.49308 29.3489 9.9784 29.3489H32.215C33.7003 29.3489 34.9043 28.1504 34.9043 26.6718V12.2366C34.9043 10.7581 33.7003 9.55957 32.215 9.55957Z",
			fill: "#0099E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5259 30.667H15.6641V33.7612H26.5259V30.667Z",
			fill: "#0099E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5259 30.667H15.6641V33.7612H26.5259V30.667Z",
			fill: "#0099E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.3643 35.0996H26.6289V18.625L28.5654 19.2148L36.3008 21.5693L37.3643 21.8926V35.0996Z",
			fill: "white",
			stroke: "#C2E6F2",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8643 33.5996V23.0039L28.1289 20.6494V33.5996H35.8643ZM36.3643 34.0996H27.6289V19.9746L36.0098 22.5254L36.3643 22.6338V34.0996Z",
			fill: "#002749"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0891 20.0114L23.2079 19.3063L15.8242 14.6992L16.4973 23.3285L18.3833 20.8182L20.6803 24.8492L21.6509 24.2664L22.6167 23.6874L20.0891 20.0114Z",
			fill: "#C2E6F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.4576 24.8496H29.5352V26.2496H34.4576V24.8496Z",
			fill: "#002749"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.4576 27.2998H29.5352V28.6998H34.4576V27.2998Z",
			fill: "#002749"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.4576 29.75H29.5352V31.15H34.4576V29.75Z",
			fill: "#002749"
		})
	]
});
export default SvgGroupTypeOffice;
